import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { MobileActionBar } from "@/components/site/MobileActionBar";

export const Route = createFileRoute("/_site")({
  component: SiteLayout,
});

function SiteLayout() {
  return (
    <>
      <Header />
      <main id="main" className="min-h-[60svh]">
        <Outlet />
      </main>
      <Footer />
      <MobileActionBar />
    </>
  );
}
